/**
 * className 결합 유틸 (호환) — kingdoo-editor utils/cn.ts 와 동일 동작.
 * falsy 값을 거르고 공백으로 join.
 */
export function cn(...inputs) {
  return inputs.filter(Boolean).join(' ');
}
